import { useReactiveVar } from "@apollo/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { authenticationStateVar } from "@/apollo/auth-state";

/**
 * Requires the user to be authenticated. Redirects to /login otherwise.
 * Equivalent to the legacy AuthenticatedRoute.
 */
export function AuthenticatedRoute() {
  const { authenticated } = useReactiveVar(authenticationStateVar);
  const location = useLocation();

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

/**
 * Requires the user to be authenticated AND have at least one Instagram
 * account. Redirects to /create otherwise.
 * Equivalent to the legacy ProtectedRoute.
 */
export function ProtectedRoute() {
  const { authenticated, accounts } = useReactiveVar(authenticationStateVar);
  const location = useLocation();

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (accounts.length === 0) {
    return <Navigate to="/create" replace />;
  }
  return <Outlet />;
}

/**
 * Public route — bounces authenticated users to /build.
 * Equivalent to the legacy PublicRoute.
 */
export function PublicRoute() {
  const { authenticated } = useReactiveVar(authenticationStateVar);

  if (authenticated) {
    return <Navigate to="/build" replace />;
  }
  return <Outlet />;
}
